<template>
    <Modal2
        v-if="showModal"
        :title="$t('userInfoWidget.adsYouAreInterestedIn')"
        @cancel="closeModal"
        :show-footer="false"
        class-name="forwardRepresentativeModal"
    >
        <ve-table
            :columns="getColumns()"
            :table-data="metaReferrals"
            :row-style-option="rowStyleOption"
            :border-x="true"
            :border-y="true"
            row-key-field-name="_id"
            id="meta-referrals-table"
            :fixed-header="true"
        />

    </Modal2>
</template>
<script>
import Vue from "vue";
import Modal2 from "../common/Modal2.vue";
import { VeLocale, VePagination } from "vue-easytable";
import enUS from "vue-easytable/libs/locale/lang/en-US.js";
import moment from "moment";

Vue.use(VePagination);
VeLocale.use(enUS);


export default {
    name: "VisitorMetaReferralsModal",
    props: {
        metaReferrals: {
            type: Array,
            required: true,
        },
        modaladvertisingdetail: {
            type: Boolean,
            required: true,
        },
    },
    components: { Modal2 },
    data() {
        return {
            visitor: [],
            showModal: this.modaladvertisingdetail,
            rowStyleOption: {
                stripe: true,
            },
        };
    },
    watch: {
        modaladvertisingdetail(newValue) {
            this.showModal = newValue;
        },
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        getColumns() {
            return [
                {
                    field: "sourceType",
                    key: "sourceType",
                    title: this.$t("userInfoWidget.resourceType"),
                    renderBodyCell: ({ row }, h) => {
                        return <span>{row.sourceType}</span>;
                    },
                },
                {
                    field: "sourceId",
                    key: "sourceId",
                    title: this.$t("userInfoWidget.sourceID"),
                },
                {
                    field: "sourceLink",
                    key: "sourceLink",
                    title: this.$t("userInfoWidget.adUrl"),
                    renderBodyCell: ({ row }, h) => {
                        return (
                            <a href={row.sourceLink} target="_blank">
                                {row.sourceLink && row.sourceLink.length > 100 ? row.sourceLink.substring(0, 100) + "..." : (row.sourceLink ? row.sourceLink : "N/A")}
                            </a>
                        );
                    },
                },
                {
                    field: "headline",
                    key: "headline",
                    title: this.$t("userInfoWidget.adsTitle"),
                },
                {
                    field: "body",
                    key: "body",
                    title: this.$t("userInfoWidget.adsBody"),
                },
                {
                    field: "createdAt",
                    key: "createdAt",
                    title: this.$t("userInfoWidget.adsCreateDate"),
                    renderBodyCell: ({ row }, h) => {
                        return <span>{moment(row.createdAt).format("YYYY-MM-DD HH:mm:ss")}</span>;
                    },
                },
                {
                    field: "updatedAt",
                    key: "updatedAt",
                    title: this.$t("userInfoWidget.adsUpdateDate"),
                    renderBodyCell: ({ row }, h) => {
                        return <span>{moment(row.updatedAt).format("YYYY-MM-DD HH:mm:ss")}</span>;
                    },
                },
            ];
        },
    },
};
</script>
<style lang="scss">
.forwardRepresentativeModal {
    .ant-modal {
        width: 80% !important;
    }
}
</style>
